export default __webpack_public_path__ + "static/media/B52_10.f2a057a5.webp";